import { render } from "./Footer.vue?vue&type=template&id=62339cfc&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=62339cfc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62339cfc"]])

export default __exports__